import React from 'react';
import "../services_page/services_page.css";
import infoIcon from "../../parm_assets/tree_icons.png";

// Import your company logos here
import logo1 from "../../parm_assets/companies/rasb.png"; 
import logo2 from "../../parm_assets/companies/rasb.png";
import logo3 from "../../parm_assets/companies/rasb.png";
import logo4 from "../../parm_assets/companies/rasb.png";
import logo5 from "../../parm_assets/companies/rasb.png";
import logo6 from "../../parm_assets/companies/rasb.png";
// ... etc

const companies = [
  { logo: logo1, url: "https://www.raintreearborist.com/" },
  { logo: logo2, url: "https://www.raintreearborist.com/" },
  { logo: logo3, url: "https://www.raintreearborist.com/" },
  { logo: logo4, url: "https://www.raintreearborist.com/" },
  // Add more as needed
];

const ServicesParm = () => {
  return (
    <div className="page-container">
      <section className="about-hero-section">
        <div className="about-hero-content">
          <h1 className="about-page-title">Our Services</h1>
          <nav className="breadcrumb">
            <span className="breadcrumb-item">Home</span>
            <span className="breadcrumb-separator"> &gt; </span>
            <span className="breadcrumb-item active">Services</span>
          </nav>
        </div>
      </section>

      <section className="services-registeredcompany-section">
        <div className="container-services-registeredcompany">
          <div className="header-content-aboutus">
            <span className="eyebrow-aboutus">
              <img src={infoIcon} alt="icon" className="tree-icon" />
              REGISTERED COMPANY
            </span>
            <h2 className="main-title-aboutus">PArM’s Registered Companies</h2>
          </div>

          <div className="services-companies-grid">
            {companies.map((c, i) => (
              <div className="services-company-card" key={i}>
                {/* Logo Image instead of text */}
                <div className="company-logo-container">
                  <img src={c.logo} alt="Company Logo" className="company-card-logo" />
                </div>

                {/* Arrow wrapped in a link */}
                <a 
                  href={c.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="services-company-arrow-circle"
                >
                  <span className="services-company-arrow">→</span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesParm;